const translations = {
  cs: {
    event: {
      share: {
        title: 'Podělte se o tuto událost',
        description: 'Sdílejte tuto událost na sociálních sítích nebo ji pošlete svým přátelům.',
        copy_link: 'Zkopírovat odkaz',
        copy_link_success: 'Odkaz byl úspěšně zkopírován do schránky.',
        login_required: 'Abyste mohli posílat pozvánky, prosím <u><a href="{loginUrl}">přihlaste se</a></u> nebo <u><a href="{signupUrl}">zaregistrujte se</a></u>. Těšíme se, že se k nám připojíte!',
        send_email: 'Odeslat pozvánku',
        email_placeholder: 'Zadejte e-mail osoby, kterou chcete pozvat',
        send_email_invite: 'Poslat pozvánku e-mailem',
        share_social: 'Podpořte nás sdílením na sociálních sítích',
        invite_self_error: 'Nemůžete poslat pozvánku sami sobě. Zkuste zadat e-mail někoho jiného!',
        close: 'Zavřít',
        max_emails_error: 'Maximální počet e-mailů pro odeslání je 20',
        invite_dialog_title: 'Odeslání pozvánky e-mailem',
        duplicate_emails_error: 'Některé e-maily se zdají být duplicitní. Prosím, zkontrolujte, zda jste e-mailové adresy zadali správně.',
        email_addresses: 'Příjemci (povinné)',
        email_help_text: 'Zadejte e-mailovou adresu, pro více oddělte adresy čárkou (např. jana@aion.cz, petr@aion.cz)',
        optional_message: 'Zpráva pro příjemce (volitelné)',
        message_placeholder: 'např. Ahoj, myslím, že by tě tento webinář mohl zaujmout, protože se věnuje tématu, které ....',
        send_invite: 'Odeslat pozvánku',
        send_invites: 'Odeslat {count} pozvánky',
        send_invites_plural: 'Odeslat {count} pozvánek',
        invalid_email_format: 'Zadejte platnou e-mailovou adresu',
        message_length_error: 'Zpráva může obsahovat maximálně 300 znaků',
        message_help_text: 'Zpráva bude zvoleným příjemcům odeslána v e-mailu spolu s informacemi a odkazem na tuto událost. E-mailové adresy příjemců <strong>nebudou použity k jiným účelům</strong> než je odeslání pozvánky.',
cancel: 'Zrušit',
      }
    },
    lecturers: {
      showcase:{
        title: 'Staňte se lektorem Zákonů pro lidi',
        description: 'Sdílejte své odborné znalosti a zkušenosti prostřednictvím našich webinářů a interaktivních setkání. Připojte se k naší komunitě expertů, ovlivněte veřejnou diskusi a rozšiřte svůj dosah – váš hlas může změnit právní debatu!',
        events_count: 'Počet událostí: {count}',
      },
      profile: {
        info: "Informace",
        events: "Události",
        reviews: "Recenze",
        contact: "Kontakt",
        specializations: "Specializace",
        services: "Služby",
        brands: "Organizace",
        brand: {
          position: "Na pozici: {position}",
          website: "Přejít na web",
          email: "Poslat e-mail"
        },
        lecturerReviews: "Recenze lektora",
        loadingReviews: "Načítám recenze...",
        yourName: "Vaše jméno",
        yourEmail: "Váš e-mail",
        message: "Zpráva",
        send: "Odeslat",
        noEvents: "Žádné události nejsou k dispozici",
        phone: "Telefon",
        email: "E-mail",
        website: "Web",
        social: "Sociální sítě",
        contactInfo: "Kontaktní informace",
        getInTouch: "Kontaktujte lektora",
      },
    },
    dropdown: {
      lecturers: {
        name: 'Lektorů',
        next_upto4: ' + {count} další',
        next_above4:' + {count} dalších',
      },
      category:{
        name: 'Témata'
      },
      status: {
        'name': 'Stavu',
        planned: 'Plánované události',
        live:'Probíhající události',
        ended:'Ukončené události',
      },
      type:{
        'name': 'Typu',
        'webinars': 'Webináře',
        'events': 'Události',
        'courses': 'Kurzy',
        'conferences': 'Konference',
      },
      mode:{
        'name': 'Způsobu',
        'online': 'Online',
        'offline': 'Offline',
        'playback': 'Video záznam',
      },
      date:{
        'name': 'Data',
        'year': 'Rok {year}',
        'select_year': 'Vyberte rok',
        'select_month': 'Vyberte měsíc',
        'select_day': 'Vyberte den',
      },
      price:{
        'name' : 'Ceny',
        'aproximate': 'Přibližný počet placených událostí {count}',
        'max_price': 'Maximální cena: {price} Kč',
        'only_free': 'Pouze události zdarma',
      }
    },
    date: {
    month: {
      january: 'Leden',
      february: 'Únor',
      march: 'Březen',
      april: 'Duben',
      may: 'Květen',
      june: 'Červen',
      july: 'Červenec',
      august: 'Srpen',
      september: 'Září',
      october: 'Říjen',
      november: 'Listopad',
      december: 'Prosinec'
    },
    day: {
      sunday: 'Neděle',
      monday: 'Pondělí',
      tuesday: 'Úterý',
      wednesday: 'Středa',
      thursday: 'Čtvrtek',
      friday: 'Pátek',
      saturday: 'Sobota'
    },
  },
    errors: {
      429: {
        header: 'Příliš mnoho požadavků.',
        description:
          'Prosím, počkejte {countdown} sekund, poté se pokusíme načíst tuto stránku znovu.'
      },
      403: {
        header: 'Přístup odepřen',
        description: 'Nemáte oprávnění k přístupu k této stránce.'
      },
      500: {
        header: 'Interní chyba serveru',
        description:
          'Došlo k problému na našich serverech. Prosíme, zkuste to znovu za chvíli. Je možné, že již pracujeme na opravě. Pokud problém přetrvává, kontaktujte nás na info@zakonyprolidi.cz.'
      },
      404: {
        // Optional: Add specific header and description for 404
        header: 'Stránka nenalezena',
        description: 'Omlouváme se, ale stránka, kterou hledáte, neexistuje.'
      },
      default: {
        header: 'Chyba',
        description: 'Nastala neočekávaná chyba. Zkuste to prosím znovu.'
      }
    },
    buttons: {
      close: 'Zavřít',
      login: 'Přihlásit se',
      retry: 'Zkusit znovu',
      home: 'Přejít na domovskou stránku' // Added 'home' button translation
    },
    cookie_notification: {
      message:
        'Tato webová stránka používá soubory cookie, které jsou nezbytné pro fungování této služby. Cookie budou uloženy po dobu {days} dnů.',
      info: 'Více informací naleznete v našich <a href="{privacy_policy}">zásadách ochrany osobních údajů</a> a <a href="{terms_of_service}">podmínkách užívání</a>. Pokud máte nějaké dotazy, neváhejte nás <a href="{contact}">kontaktovat</a>.',
      agree: 'Souhlasím',
      disagree: 'Nesouhlasím',
      agree_close: 'Souhlasím a zavřít'
    },
    account_conversion: {
      title: 'Chcete si vytvořit účet?',
      description:
        'Jste přihlášen(a) jako neregistrovaný návštěvník. Pokud si vytvoříte účet, získáte možnost spravovat své události a upravovat nastavení účtu (včetně jeho odstranění). Případně můžete pokračovat bez registrace a tato nabídka se vám nebude zobrazovat následujících 24 hodin.',
      continue: 'Pokračovat bez registrace',
      register: 'Vytvořit účet'
    },
    chat: {
      loading: 'Načítám chat...'
    },
    status_badge: {
      planned: 'Plánováno',
      upcoming: 'Připravujeme',
      live: 'Událost právě teď probíhá',
      awaiting_playback: 'Připravujeme záznam',
      playback: 'Přehrajte si záznam',
      ended: 'Událost skončila',
      unknown: 'Neznámý'
    },
    event_btn: {
      webinars: {
        planned: 'Přihlásit se', // I'm interested
        upcoming: 'Přihlásit se', // Register
        live: 'Připojit se', // Join
        ended: 'Přehrát záznam', // View Recording
        default: 'Přihlásit se' // Go to Webinar
      },
      event: {
        planned: 'Registrovat se', // I'm interested
        upcoming: 'Přihlásit se', // Register
        live: 'Připojit se', // Watch (shortened from 'Sledovat událost')
        ended: 'Přehrát záznam', // View Recording
        default: 'Přihlásit se' // Go to Event
      },
      courses: {
        planned: 'Registrovat se', // I'm interested
        upcoming: 'Registrovat se', // Register (shorter alternative)
        live: 'Připojit se', // Join
        ended: 'Přehrát záznam', // View Recording
        default: 'Registrovat se' // Go to Course
      },
      conferences: {
        planned: 'Registrovat se', // I'm interested
        upcoming: 'Registrovat se', // Register (shorter alternative)
        live: 'Připojit se', // Join
        ended: 'Přehrát záznam', // View Recording
        default: 'Registrovat se' // Go to Conference
      }
    },
    event_join_btn: {
      webinars: {
        upcoming: 'Chci se zúčastnit', // I want to register
        live: 'Chci se připojit', // I want to join
        ended: 'Chci si přehrát záznam', // I want to view the recording
        default: 'Chci se přihlásit', // Default for webinars
        planned: 'Chci se zúčastnit' // I want to register
      },
      event: {
        upcoming: 'Chci se zúčastnit', // I want to register
        live: 'Chci se připojit', // I want to watch
        ended: 'Chci si přehrát záznam', // I want to view the recording
        default: 'Chci se přihlásit', // Default for events
        planned: 'Chci se zúčastnit' // I want to register
      },
      courses: {
        upcoming: 'Chci se registrovat', // I want to register
        live: 'Chci se připojit', // I want to join
        ended: 'Chci si přehrát záznam', // I want to view the recording
        default: 'Chci se registrovat', // Default for courses
        planned: 'Chci se registrovat' // I want to register
      },
      conferences: {
        upcoming: 'Chci se registrovat', // I want to register
        live: 'Chci se připojit', // I want to join
        ended: 'Chci si přehrát záznam', // I want to view the recording
        default: 'Chci se registrovat', // Default for conferences
        planned: 'Chci se registrovat' // I want to register
      }
    },
    cookies_required: {
      title: 'Omlouváme se, ale tuto službu bez cookies není možné používat.',
      message:
        'Prosím, povolte cookies pro pokračování. Cookie bude uložena po dobu {days} dnů.',
      privacy_policy: 'Zásady ochrany osobních údajů',
      terms_of_service: 'Podmínky služby',
      contact: 'Kontakt',
      accept_cookies: 'Povolit cookies'
    },
    'First and last name are required.': 'Jméno a příjmení jsou povinné.',
    day: 'den',
    from: 'od',
    'Private Event': 'Soukromá událost',
    'Return to Event List': 'Zpět na seznam událostí',
    private_message:
      'Pokud chcete zobrazit tuto událost, musíte znát heslo. Heslo bylo zasláno na vaši e-mailovou adresu a nebo vám bylo sděleno po telefonu případně jiným způsobem.',

    countdown: {
      start_text: 'Začínáme za {time_components}',
      event_ended: 'Událost již skončila',
      event_started: 'Událost již začala',
      and: 'a',
      // Days
      day: 'den',
      days_few: 'dny',
      days_many: 'dní',

      // Hours (including accusative case)
      hour_accusative: 'hodinu', // Accusative case for 1 hour
      hours_few: 'hodiny',
      hours_many: 'hodin',

      // Minutes
      minute: 'minutu',
      minutes_few: 'minuty',
      minutes_many: 'minut',

      // Seconds
      second: 'sekunda',
      seconds_few: 'sekundy',
      seconds_many: 'sekund'
    },
    January: 'leden',
    February: 'únor',
    March: 'březen',
    April: 'duben',
    May: 'květen',
    June: 'červen',
    July: 'červenec',
    August: 'srpen',
    September: 'září',
    October: 'říjen',
    November: 'listopad',
    December: 'prosinec',
    'Phone number is required.': 'Telefonní číslo je povinné.',
    'Please enter a valid phone number.': 'Zadejte platné telefonní číslo.',
    'Email address is required.': 'Emailová adresa je povinná.',
    'Please enter a valid email address.': 'Zadejte platnou emailovou adresu.',
    'First name is required.': 'Jméno je povinné.',
    'Last name is required.': 'Příjmení je povinné.',
    'Enter your phone number': 'Zadejte své telefonní číslo',
    'Meet Event Lecturers': 'Lektoři',
    'Send E-mail': 'Poslat e-mail',
    'View website': 'Přejít na web',
    Restricted: 'Soukromá událost',
    'Sign in to your account': 'Přihlaste se ke svému účtu',
    'We are processing your payment!': 'Zpracováváme platbu, čekejte..',
    'This actor has not provided a bio.': 'Čekáme na dodání biografie.',
    'Email address': 'Emailová adresa',
    Password: 'Heslo',
    'Pay Now': 'Pokračovat v objednávce',
    'Restricted Event': 'Omezený přístup',
    'Remember me': 'Zapamatuj si mě',
    'Password Recovery': 'Obnova hesla',
    'Meet Event Actors': 'Účinkující',
    'Lost your password? Recover it here.':
      'Ztratili jste heslo? Obnovte ho zde.',
    'Forgot your password?': 'Zapomněli jste heslo?',
    'Don’t have an account? Create one!': 'Nemáte účet? Vytvořte si účet zde.',
    'Have an account? Sign in.': 'Máte již účet? Přihlaste se zde.',
    'Send Password Reset Link': 'Odeslat odkaz pro obnovu hesla',
    'Login to Event Management System.':
      'Přihlaste se do systému správy událostí.',
    'Legal information': 'Právní informace',
    'All Rights Reserved': 'Všechna práva vyhrazena',
    'Select from Attendees': 'Vyberte z účastníků',
    'Please select an attendee from the options below or add a new one.':
      'Vyberte účastníka z možností níže nebo přidejte nového.',
    'Select an attendee': 'Vyberte účastníka',
    'Create an invite': 'Vytvořte pozvánku',
    'Did you forget something?': 'Nezapomněli jste na něco?',
    'If you want, you can add the following extras to this event.':
      'Pokud chcete, můžete k této události přidat následující doplňky.',
    'Other members of the organization': 'Další členové organizace',
    'Select member from organization': 'Vyberte člena organizace',
    'Show package details': 'Zobrazit podrobnosti o balíčku',
    'Hide package details': 'Skrýt podrobnosti o balíčku',
    From: 'Od',
    'Buy Ticket': 'Koupit lístek',
    'Scan to Pay': 'Naskenujte kód pro zaplacení',
    'Or add new contact': 'Nebo vyplňte informace o novém účastníkovi',
    'Add another attendee to this Event!':
      'Přidejte dalšího účastníka na tuto událost!',
    'Create an account to join events.':
      'Vytvořte si účet pro účast na událostech.',
    'Sign in': 'Přihlásit se',
    'Create account': 'Vytvořit účet',
    'Pay now': 'Zaplatit nyní',
    'Send e-mail': 'Odeslat e-mail',
    'Send invite via e-mail': 'Odeslat pozvánku e-mailem',
    'Share via Social Media': 'Sdílet na sociálních sítích',
    'Copy URL': 'Kopírovat URL',
    'Recipient Email': 'Email příjemce',
    'Sorry, you must first sign-up to this event before you can invite via e-mail.':
      'Omlouváme se, nejprve se musíte přihlásit k této události, než budete moci odeslat pozvánku e-mailem.',
    Register: 'Registrace',
    Login: 'Přihlášení',
    Copy: 'Kopírovat',
    Break: 'Přestávka',
    Program: 'Program',
    'Unnamed Stage': 'Stage bez názvu',
    'Share via URL': 'Sdílet pomocí URL',
    'Invitation sent successfully.': 'Pozvánka úspěšně odeslána.',
    'An error occurred while sending the invitation.':
      'Při odesílání pozvánky došlo k chybě.',
    'After receiving payment, we will automatically send confirmation of participation and tickets to all participants.':
      'Po obdržení platby automaticky zašleme potvrzení o účasti a vstupenky (instrukce) všem účastníkům.',
    'Add Attendee': 'Přidat účastníka',
    'Forgot Password': 'Zapomenuté heslo',
    'Join Now': 'Chci se zúčastnit',
    'Total to pay': 'Celkem k úhradě',
    'Total including VAT': 'Celkem včetně DPH',
    'Price without VAT': 'Cena bez DPH',
    'VAT Amount': 'DPH',
    'Event Date': 'Datum',
    'This is offline event, once you sign-up we will issue ticket, so you need to get to address bellow.':
      'Toto je offline událost, po registraci vám vystavíme vstupenku, takže se dostavte na adresu níže.',
    Price: 'Cena',
    Limits: 'Omezení',
    'URL copied to clipboard.': 'URL zkopírována do schránky.',
    'Shipping Costs': 'Cena za dopravu',
    'Email already exist':
      'Účet s touto e-mailovou adresou již existuje, prosím přihlaste se.',
    Subtotal: 'Celkem bez DPH',
    Attendees: 'Účastníci',
    Logout: 'Odhlásit se',
    Name: 'Jméno',
    Email: 'E-mail',
    Recapitulation: 'Rekapitulace',
    'Same Day': 'Tentýž den',
    'Ticket Price': 'Cena za vstupenku',
    'Add to Cart': 'Přidat do košíku',
    'Add Ticket to Cart': 'Přidat vstupenku do košíku',
    'Package Price': 'Cena za balíček',
    'Add Package to Cart': 'Přidat balíček do košíku',
    'Next<br>Package': 'Následující<br>balíček',
    'Previous<br>Package': 'Předchozí<br>balíček',
    'Hide Package Details': 'Skrýt obsah balíčku',
    'Show Package Details (%s items)': 'Zobrazit obsah balíčku (%s)',
    'To cart': 'Do košíku',
    'Upcoming Events': 'Nadcházející události',
    'Do you want to participate in one of the other upcoming events?':
      'Pokud máte zájem, rádi vás uvítáme i na dalších připravovaných akcích.',
    'Loading upcoming events...': 'Načítám události...',
    'Select Package': 'Možnosti',
    'Review & Confirm': 'Rekapitulace',
    'Order Confirmation': 'Potvrzení objednávky',
    'Please check the summary of your order below.': 'Prosím, zkontrolujte si níže souhrn Vaší objednávky.',
    'Create Order with Payment Obligation': 'Vytvořit objednávku se závazkem platby',
    article_73: 'Pokud se událost uskuteční dříve jak za 14 dnů. Přihlášením se na takovou událost souhlasíte a berete na vědomí, že nebude možné odstoupit od smlouvy <u><a target="_blank" href="{termsUrl}">podle čl. 7.3 Podmínek</a></u>.',
    article_73_error: 'Pro pokračování musíte souhlasit s obchodními podmínkami.',
    'Order Summary': 'Shrnutí objednávky',
    'You are about to create an order with payment obligation.': 'Chystáte se vytvořit objednávku se závazkem platby.',
    recapitulation_agree: 'Kliknutím na "Vytvořit objednávku se závazkem platby" souhlasíte s našimi <u><a target="_blank" href="{termsUrl}">obchodními podmínkami</a></u> a potvrzujete, že zaplatíte za vybrané události. Zálohovou fakturu obdržíte na vaši e-mailovou adresu.',
    'Continue to Order Confirmation': 'Pokračovat na potvrzení objednávky',
    'Back to Confirmation': 'Zpět na potvrzení objednávky',
    'Thank You for Your Order!': 'Děkujeme za Vaši objednávku!',
    'Your order has been created successfully.': 'Vaše objednávka byla úspěšně vytvořena.',
    'Your payment has been successfully processed.': 'Vaše platba byla úspěšně zpracována.',
    'A confirmation email has been sent to your email address.': 'Na Vaši e-mailovou adresu bylo odesláno potvrzení.',
    'Please proceed with payment using one of the methods below.': 'Prosím, dokončete svou objednávku pomocí jedné z platebních metod níže.',
    'You can download your invoice from your account page.': 'Svou fakturu si můžete stáhnout ze stránky svého účtu.',
    'The event has been added to your account. You can access it anytime.': 'Událost byla přidána do vašeho účtu. Můžete k ní přistupovat kdykoliv.',
    'Back to Event Page': 'Zpět na stránku události',
    thank_you_subtitle:'Díky vám se můžeme zlepšovat a pořádat skvělé akce, <strong>mnohdy i zdarma</strong>.<br> Vážime si vaší přízně. 🙏🧡',
    'Back to Event': 'Zpět na událost',
    'Please enter a valid email address': 'Zadejte platnou e-mailovou adresu',
    'Send Proforma Invoice to E-mail': 'Odeslat zálohovou fakturu na e-mail',
    proforma_modal_description:'Můžeme zálohovou fakturu zaslat na váš e-mail, nebo byste si přáli, abychom ji odeslali někomu jinému?',
    proforma_modal_title:'Zaslat zálohovou fakturu na e-mail',
    'Failed to send proforma invoice': 'Odeslání zálohové faktury se nezdařilo',
    'Failed to send proforma invoice. Please try again.': 'Odeslání zálohové faktury se nezdařilo. Zkuste to prosím znovu.',
    'Proforma invoice has been sent to the specified email address': 'Zálohová faktura byla odeslána na zadanou e-mailovou adresu',
    'Sending...': 'Odesílání...',
    'Send Invoice': 'Odeslat fakturu',
    'Share this Event!': 'Sdílejte tuto událost!',
    'You can share this event with your friends or colleagues.':
      'Sdílejte tuto událost s přáteli nebo kolegy.',
    'You can either buy a single ticket or choose a package that includes the event.':
      'Některé události jsou nabízeny za výhodnější cenu, pokud je zakoupíte v balíčku spolu s dalším školením.',
    'Choose Your Option': 'Vyberte si možnost',
    'Continue to Summary': 'Pokračovat na rekapitulaci',
    'Continue to Payment': 'Pokračovat na platbu',
    'Pay for This Event':
      'Pokud si chcete zakoupit vstupenku na tuto události klikněte níže:',
    'No items in cart': 'Váš košík je prázdný',
    'Remove from cart': 'Odebrat z košíku',
    'Buy a Package and Save!':
      'Pro zakoupení balíčku včetně vstupenky na tuto události klikněte níže:',
    'Add Addon': 'Přidat příplatek',
    'An error occurred. Please try again later.':
      'Došlo k chybě. Prosím zkuste to znovu později.',
    'Verification Code': 'Ověřovací kód',
    'New Password': 'Nové heslo',
    'Confirm New Password': 'Potvrďte nové heslo',
    'Verify Code and Set Password': 'Ověřit kód a nastavit heslo',
    'Send Verification Code': 'Odeslat ověřovací kód',
    'Your cart is empty!': 'Váš košík je prázdný!',
    'Please select at least one item to continue.':
      'Vyberte zda si chcete zakoupit vstupenku jen na tuto událost a nebo celý balíček.',
    'Loading, please wait...': 'Načítám, prosím čekejte...',
    'Already Signed Up': 'Již jste přihlášen(a)',
    "Don't wait—spots are limited to %s. We already have %s. Secure your spot today and don't miss this unique opportunity!":
      'Nečekejte, počet míst je omezen na %s. Už máme %s. Zajistěte si své místo ještě dnes a nezmeškejte tuto jedinečnou příležitost!',
    'Register %s now!': 'Registrujte se %s nyní!',
    'Your cart is empty': 'Váš košík je prázdný',
    'Shipping costs are applied only if any items require shipping.':
      'Cena za dopravu se přičítá, pokud některá položka vyžaduje dopravu.',
    'Package discount %s% are subtracted from the product prices before VAT.':
      'Sleva balíčku %s% je odečtena z cen jeho položek bez DPH',
    'Total Discount': 'Celková sleva',
    'Apply Voucher, Gift Card, or Coupon': 'Máte slevový kód a nebo poukaz?',
    'Organization Security Question':
      'Bezpečnostní otázka (ověřte, že patříte k organizaci)',
    'Save Answer': 'Uložit odpověď',
    'Your Answer': 'Vaše odpověď',
    Join: 'Přihláška',
    Submit: 'Uložit',
    Cancel: 'Zrušit',
    Share: 'Sdílet',
    Show: 'Zobrazit podrobnosti',
    Hide: 'Skrýt podrobnosti',
    Close: 'Zavřít',
    Events: 'Události',
    Coupons: 'Slevové kupóny',
    Included: 'Zahrnuje také',
    Savings: 'Zahrnuté slevy',
    'Cart Summary': 'Nákupní košík',
    'Payer Details': 'Plátce',
    Payment: 'Platba',
    Free: 'Zdarma',
    Featured: 'Doporučujeme',
    Previous: 'Předchozí',
    Next: 'Následující',
    'Go to first page': 'Přejít na první stránku',
    'Go to previous page': 'Přejít na předchozí stránku',
    'Current page': 'Aktuální stránka',
    'Go to page': 'Přejít na stránku',
    'Go to next page': 'Přejít na další stránku',
    'Go to last page': 'Přejít na poslední stránku',
    'We will send you the invoice to the email address %s.':
      'Fakturu vám zašleme na emailovou adresu: %s.',
    'Please login or register before continuing':
      'Před pokračováním se přihlaste a nebo zaregistrujte',
    "I don't have an account": 'Nemám účet',
    'I already have an account': 'Již mám účet',
    'Pay for %s': 'Platba za %s',
    'Email Address': 'Emailová adresa',
    'Password Confirmation': 'Potvrzení hesla',
    'First Name': 'Jméno',
    'Organization or Company Name': 'Název organizace nebo společnosti',
    'Job position': 'Pracovní pozice',
    'Last Name': 'Příjmení',
    Degree: 'Titul',
    'Remember Me': 'Zapamatovat přihlášení',
    'Phone Number': 'Telefonní číslo',
    'Company Name': 'Jméno / Název společnosti',
    'Company Number': 'IČO',
    'Company City': 'Město',
    'Company ZIP code': 'PSČ',
    'Company VAT Number': 'DIČ',
    Country: 'Země',
    'Company Address': 'Adresa společnosti',
    'Also create an account for me': 'Chci si rovnou vytvořit i účet',
    'I want to enter billing information': 'Chci zadat fakturační údaje',
    'Protected by Google reCAPTCHA': 'Chráněno službou Google reCAPTCHA',
    'Join %s': 'Přihláška na %s',
    'Login and Continue': 'Přihlásit se a pokračovat',
    'Please fill out this short form or log in before continuing.':
      'Před pokračováním vyplňte tento krátký formulář nebo se přihlaste.',
    'Enter your first name': 'Zadejte své jméno',
    'Enter your last name': 'Zadejte své příjmení',
    Organization: 'Organizace',
    'Enter or search for an organization': 'Zadejte nebo vyhledejte organizaci',
    'Save and Continue': 'Uložit a pokračovat',
    'Package Includes': 'Balíček obsahuje',
    'Please select an attendee or invitee or enter a new contact.':
      'Vyberte účastníka nebo pozvaného nebo zadejte nový kontakt.',
    'Failed to load cart content': 'Nepodařilo se načíst obsah košíku',
    'Failed to update quantity': 'Nepodařilo se aktualizovat množství',
    'Error fetching cart content': 'Chyba při načítání obsahu košíku',
    'I agree to': 'Souhlasím s',
    'our Terms & Conditions': 'obchodními podmínkami',
    'and with': 'a',
    'our Privacy Policy': 'zásadami ochrany osobních údajů',
    'I want to pay only for this event': 'Chci zaplatit pouze za tuto událost',
    'or buy package and save!': 'nebo si zakoupte balíček a ušetříte!',
    Addons: 'Další možnosti',
    Error: 'Varování',
    Saved: 'Uloženo',
    Save: 'Uložit',
    'FREE SHIPPING': 'ZDARMA',
    Edit: 'Upravit',
    Settings: 'Nastavení',
    Invoices: 'Faktury',
    Unfilled: 'Účastník',
    Note: 'Poznámka',
    Info: 'Informace',
    Success: 'Úspěch',
    Warning: 'Upozornění',
    'Please agree to the terms.': 'Musíte souhlasit s našimi podmínkami.',
    'Please fill in the company information first.':
      'Nejprve vyplňte název organizace a nebo společnosti.',
    'Field %s must contain at least %s characters.':
      'Pole %s musí obsahovat alespoň %s znaků.',
    'Passwords do not match.': 'Hesla se neshodují.',
    'Please enter an email address.': 'Zadejte emailovou adresu.',
    'Field %s can not be empty.': 'Pole %s nemůže být prázdné.',
    'Allow displaying my real name and working position to other participants':
      'Přeji si zobrazit mé jméno a pracovní pozici ostatním účastníkům a návštěvníkům události',
    'Subscribe to receive invites to future events':
      'Přeji si dostávat e-mailová upozornění na budoucí události',
    'Password must be at least 6 characters long.':
      'Heslo musí být alespoň 6 znaků dlouhé.',
    Sex: 'Pohlaví',
    Male: 'Muž',
    Female: 'Žena',
    Other: 'Jiné',
    'Enter Code': 'Zadejte kód',
    Apply: 'Uplatnit',
    'Name or Business Name': 'Jméno nebo obchodní název',
    'Company ID': 'IČO',
    'Company VAT ID': 'DIČ',
    'Gift Code': 'Poukaz',
    'Remaining Balance': 'Zbývající zůstatek z poukazu na příští nákup',
    Address: 'Adresa',
    City: 'Město',
    'Failed to load content.':
      'Nepodařilo se načíst obsah. Zkuste to znovu později.',
    'Czech Republic': 'Česká republika',
    'Slovak Republic': 'Slovensko',
    'Zip Code': 'PSČ',
    Services: 'Služby',
    Specializations: 'Specializace',
    'Edit Billing Address': 'Úprava fakturační adresy',
    'Edit Shipping Address': 'Úprava dodací adresy',
    'Shipping Address': 'Dodací adresa',
    'Billing Address': 'Fakturační adresa',
    'We will issue invoice to the address you provide.':
      'Fakturu vám vystavíme na tyto fakturační údaje.',
    'Since some items require delivery, please provide the information needed for shipping your items.':
      'Jelikož některé položky z vaší objednávky vyžadují doručení, zadejte prosím nezbytné informace.',
    'Billing address is not available.':
      'Prosíme vyplňte si fakturační adresu.',
    'Shipping address is not available.': 'Prosíme vyplňte si dodací adresu.',
    'Alternative Payment Methods': 'Další způsoby platby',
    'QR Code': 'QR platba',
    'Variable Symbol': 'Variabilní symbol',
    'Back to %s': 'Zpět na %s',
    'Back to Options': 'Zpět na možnosti',
    'Now please pay for this event': 'Nyní prosím zaplaťte za tuto událost',
    'You are now registered for this event':
      'Nyní jste registrováni na tuto událost',
    'Back to Summary': 'Zpět na rekapitulaci',
    'Price per person': 'Cena za osobu',
    'This event is organized by': 'Spolupořadatel',
    'FREE EVENT': 'ZDARMA',
    '%s is free of charge!': '%s je zdarma!',
    'Crypto Payment Methods': 'Platba přes Bitcoin',
    Amount: 'Částka',
    Rate: 'Kurz',
    'Open in Wallet': 'Otevřít v peněžence',
    'Price: %s': 'Cena: %s',
    'Event is about to start!': 'Událost právě začíná!',
    'Price is %s per person (Inc. %s% Tax)':
      'Cena je %s za osobu (včetně %s% DPH)',
    'Clear Selection': 'Zrušit výběr',
    'Terms & Conditions': 'Podmínky služby (VOP)',
    'Copyright %s © %s': '%s © %s',
    'Contact us': 'Kontaktujte nás',
    'Cookies Policy': 'Soubory cookie zásady',
    'User Account': 'Uživatelský účet',
    'Event Types': 'Typy událostí',
    'Categories of %s': 'Kategorie %s',
    Search: 'Vyhledávání',
    result: 'výsledek',
    results: 'výsledky',
    few_results: 'výsledky',
    many_results: 'výsledků',
    '%s %s for category „%s“ which contain „%s“':
      '%s %s pro kategorii “%s“, které obsahují “%s“',
    '%s %s for category „%s“': '%s %s v kategorii “%s“',
    '%s %s for search term „%s“': '%s %s pro vyhledávací termín “%s“',
    '%s %s found': 'Nalezeno %s %s',
    no_results_for_category_search:
      'Nebyly nalezeny žádné výsledky v kategorii “%s“, které obsahují “%s“', // Add this line
    no_results_for_category: 'Nebyly nalezeny žádné výsledky v kategorii “%s“', // Add this line
    no_results_for_search:
      'Nebyly nalezeny žádné výsledky pro vyhledávací termín “%s“', // Add this line
    no_results_found: 'Nebyly nalezeny žádné výsledky', // General no results line

    'We are sorry, but currently there are no items available.':
      'Omlouváme se, ale zatím zde nejsou k dispozici žádné události.',
    'Number of attendees of %s is limited': 'Počet účastníků %s je omezen',
    'Account Number': 'Číslo účtu',
    'Download Proforma Invoice': 'Stáhnout zálohovou fakturu',
    'Bank Transfer Details': 'Platba bankovním převodem',
    'Amount to Pay': 'Částka k úhradě',
    'This event is free of charge': 'Tato událost je zdarma',
    'Max number of attendees for <b>%s</b> is limited to <b>%s</b>, currently %s %s.':
      'Maximální počet účastníků pro <b>%s</b> je omezen na <b>%s</b>, momentálně se %s <b>%s</b>.',
    '%s starting %s at %s, %s': '%s začíná %s v %s',
    'Starting Date': 'Začátek',
    'Preview Video': 'Náhledové video',
    'Previous %s': 'Předchozí %s',
    'Upcoming %s': 'Následující %s',
    'This event is free': 'Tato událost je zdarma',
    'Enter your email': 'Zadejte váš email',
    'Payment has been received successfully':
      'Platba byla úspěšně přijata, děkujeme!',
    'Enter your password': 'Zadejte vaše heslo',
    'Enter verification code': 'Zadejte ověřovací kód',
    'Enter new password': 'Zadejte nové heslo',
    'Confirm new password': 'Potvrďte nové heslo jeho zopakováním',
    'Search or enter company name': 'Vyhledejte nebo zadejte název společnosti',
    'Search or enter position': 'Vyhledejte nebo zadejte pracovní pozici',
    'Ending Date': 'Konec',
    'Loading form...': 'Načítání formuláře...',
    'Including %s% VAT': 'včetně %s% DPH',
    '%s has left %s': '%s opustil(a) %s',
    '%s has joined %s': '%s se připojil(a) na %s',
    'Search events...': 'Fulltextové vyhledávání...',
    'Meet Our Lecturers': 'Seznamte se s našimi lektory',
    'Limited to %s spots. Already %s registered!':
      'Kapacita %s míst, již se přihlásilo %s.',
    'How to join %s?': 'Jak se zúčastnit %s?',
    Duration: 'Délka',
    event_mode_online_description_1:
      'K této události se můžete připojit z pohodlí domova nebo kanceláře. Jakmile událost začne, <strong>budete k události připojeni automaticky přímo na této stránce</strong>.',
    event_mode_online_description_2:
      'Po registraci k události obdržíte také e-mail s přístupem k této události prostřednictvím desktopové aplikace. Toto řešení můžete použít například v případě technických problémů.',
    event_mode_online_description_3:
      '<strong>Pro tuto událost bude rovněž vytvořen záznam</strong>, který se objeví všem přihlášeným účastníkům přímo na této stránce obvykle několik hodin po skončení události. To znamená, že pokud se z nějakého důvodu nestihnete zúčastnit, můžete si přehrát video záznam kdykoliv později.',
    events_all_tab_name: 'Události',
    events_all_tab_plural: 'Události',
    events_all_tab_accusative: 'Událostí',
    'Back to list <span>of %s</span>': 'Zpět na výpis <span>%s</span>',
    '%s minutes': '%s minut',
    'Click here': 'Klikněte zde',
    'Submit Form': 'Uložit formulář',
    'Go to video': 'Přejít na stránku videa',
    'Join Event': 'Zúčastnit se události',
    'Image Notification': 'Obrázek',
    'An image has been shared with you.': 'Byl s vámi sdílen obrázek.',
    'File Download': 'Soubour ke stažení',
    'Click here to download': 'Stáhnout soubor',
    'By clicking to button below you can download the file.':
      'Kliknutím na tlačítko níže si můžete tento soubor stáhnout.',
    'Action Required': 'Přejete si pokračovat?',
    'What is your opinion?': 'Jaký je váš názor?',
    'Edit Review': 'Úprava zpětné vazby',
    'Submit Review': 'Odeslat zpětnou vazbu',
    'Create Review': 'Vyplnit zpětnovazební formulář',
    rating_new_review:
      'Vaše zpětná vazba je pro nás velmi důležitá a pomáhá nám neustále zlepšovat kvalitu našich služeb.',
    rating_existing_review:
      'Děkujeme za vaši zpětnou vazbu. Pokud potřebujete něco změnit, můžete svůj názor před tím, než bude recenze schválena upravit.',
    'Lector Rating': 'Hodnocení lektora',
    'Rate the lector from 1 to 10 stars.':
      'Ohodnoťte lektora od 1 do 10 hvězdiček.',
    'Content Rating': 'Hodnocení obsahu',
    'Rate the content quality from 1 to 10 stars.':
      'Ohodnoťte kvalitu obsahu od 1 do 10 hvězdiček.',
    'Overall Rating': 'Hodnocení užitečnosti',
    'Give an overall rating for the experience from 1 to 10 stars.':
      'Ohodnoťte celkový zážitek od 1 do 10 hvězdiček.',
    Review: 'Vaše recenze',
    'Please provide a detailed review of your experience.':
      'Napište nám podrobnou recenzi vašeho zážitku, tento text může být viditelný i pro ostatní.',
    Suggestions: 'Vaše doporučení',
    'Thank you for signing up for the event!': 'Děkujeme Vám za účast!',
    'The video playback is now available. Feel free to watch it at your convenience.':
      'Video záznam je již nyní k dispozici. Můžete si jej tak kdykoliv přehrát přímo na této stránce.',
    'The video playback is now available. You can watch it at your convenience.':
      'Záznam z akce je nyní k dispozici. Můžete si jej přehrát, kdykoliv vám to bude vyhovovat.',
    'The video playback will be available soon. We will notify you once it is ready.':
      'Záznam z akce bude brzy k dispozici. Jakmile bude připraven, budeme vás informovat.',
    'Once you have watched the event, we would greatly appreciate your feedback.':
      'Chtěli bychom Vás také poprosit o zpětnou vazbu - tu můžete vyplnit jednoduše pomocí formuláře, který naleznete níže.',
    'Video playback has not yet been uploaded, please try again later.':
      'Záznam události ještě nebyl nahrán, zkuste to prosím později.',
    'Loading video playback, please wait...': 'Probíhá načítání zaznamu..',
    'Once the video is ready, you will receive an email notification.':
      'Jakmile bude video připraveno, obdržíte upozornění e-mailem.',
    'Save Billing Address': 'Uložit fakturační adresu',
    'Any suggestions to improve the content or experience?':
      'Zajímají nás vaše nápady a návrhy a také o jaká témata byste měli zájem v budoucnu.',
    'Make review public?': 'Souhlasíte s uveřejněním recenze?',
    'Enable this to make your review visible to others.':
      'Povolte tuto možnost, aby byla vaše recenze viditelná pro ostatní.',
    'Display your name publicly?': 'Zobrazit vaše jméno veřejně?',
    'Enable this if you want your name to be visible with your review.':
      'Povolte tuto možnost, pokud chcete, aby vaše jméno bylo čitelné (bez anonymizace).',
    'Update Review': 'Uložit změny',
    'View Uploaded File': 'Zobrazit nahraný soubor',
    'There was upload Data for this Event':
      'K této události byly nahrány přílohy',
    'Click on a file you want to download below':
      'Níže můžete kliknout a stáhnout nahrané soubory',
    'This file has been downloaded %s times': 'Tento soubor byl stažen %s krát',
    'Your review has already been approved and cannot be updated.':
      'Vaše recenze již byla schválena a nelze ji upravit, pokud v ní potřebujete udělat změny, můžete nás kontaktovat.',
    'Review submitted successfully.': 'Vaše recenze byla uložena, děkujeme.',
    'Error submitting review.': 'Recenzi se nepodařilo uložit, omlouváme se.',
    'Review Approved': 'Recenze již byla schválena',
    'For registered users only!': 'Stažení pouze pro registrované!',
    'If you want to download this file, you have to join the event first.':
      'Pokud si tento soubor přejete stáhnout, nejprve se musíte k události registrovat.',
    'Event Ratings': 'Hodnocení události',
    'Below is a summary of how attendees rated this event.':
      'Níže naleznete hodnocení této akce od účastníků.',
    'Lector Average Rating': 'Celkové hodnocení lektora',
    'Content Average Rating': 'Celkové hodnocení obsahu',
    'Overall Average Rating': 'Celkové hodnocení',
    instructorRating: 'Jak byste ohodnotili lektora?',
    instructorRatingExplanation:
      '1: Lektor byl nejasný, nepřipravený a neuměl odpovídat na otázky.<br>10: Lektor byl velmi srozumitelný, dobře připravený a dokázal výborně reagovat na otázky.',
    contentRating: 'Jak byste ohodnotili kvalitu obsahu?',
    contentRatingExplanation:
      '1: Obsah byl zmatený, nesrozumitelný a nepřinesl žádné nové informace.<br>10: Obsah byl logicky uspořádaný, přehledný a přinesl hodnotné a užitečné informace.',
    technicalRating: 'Jak byste ohodnotili technické zázemí?',
    technicalRatingExplanation:
      '1: Kvůli technickým problémům jsem se nemohl/a připojit nebo používat systém.<br>10: Vše proběhlo hladce, systém byl rychlý a bez jakýchkoli technických problémů.',
    days: {
      singular: 'den',
      few: 'dny',
      many: 'dnů'
    },
    hours: {
      singular: 'hodinu',
      few: 'hodiny',
      many: 'hodin'
    },
    minutes: {
      singular: 'minutu',
      few: 'minuty',
      many: 'minut'
    },
    seconds: {
      singular: 'sekund',
      few: 'sekund',
      many: 'sekund'
    },
    'Starting In': 'Začínáme za',
    'Event is about to start, please wait..':
      'Událost začne každým okamžikem, prosím čekejte..',
    'Created at': 'Datum',
    'Total Due': 'Celkem k úhradě',
    'Order fully paid': 'Objednávka plně zaplacena',
    'View Proforma Invoice': 'Stáhnout zálohovou fakturu',
    'Invoice ID': 'ID faktury',
    Download: 'Stáhnout',
    Type: 'Typ',
    Correction: 'Dobropis',
    'Transaction ID': 'ID transakce',
    'Job Position': 'Pracovní pozice',
    incomplete_account_information: 'Neúplné informace o účtu',
    account_missing_information_message:
      'Tento účet má chybějící informace. Před pokračováním prosím aktualizujte údaje o svém účtu.',
    go_to_settings: 'Přejít do nastavení',
    'Delete Account': 'Smazat účet',
    Invoice: 'Faktura',
    'Waiting payment': 'Čekáme platbu',
    'Back to Event List': 'Zpět na události',
    Payments: 'Platby',
    Preferences: 'Předvolby',
    Contracts: 'Smlouvy',
    'Partner Program': 'Partnerský program',
    'No items to invoice': 'Nebyly nalezeny žádné položky k fakturaci!',
    Certificates: 'Certifikáty',
    Tickets: 'Vstupenky',
    'Payments & Invoices': 'Platby a faktury',
    'Vouchers & Gift Cards': 'Poukazy a dárkové karty',
    Order: 'Objednávka',
    'Pending Overpayment Resolution': 'Čeká na vyřešení přeplatku',
    Reference: 'Odkaz',
    Gateway: 'Platební brána',
    Total: 'Celkem',
    'Download Invoice': 'Stáhnout fakturu',
    'Created At': 'Datum',
    Fulfilled: 'Plnění zapnuto',
    'Not Fulfilled': 'Plnění vypnuto',
    'Deferred Billing': 'Odložená fakturace',
    'No payments found.': 'Nebyly nalezeny žádné platby.',
    'Account Preferences': 'Nastavení převoleb',
    'Promote Publicly': 'Chci být viditelný veřejně',
    'Allow your profile to be visible publicly without anonymization.':
      'Povolit, aby byl váš profil viditelný veřejně bez anonymizace ostatním uživatelům a návštěvníkům událostí.',
    'Subscribe to Newsletter': 'Přihlásit se k odběru novinek',
    'Receive information about upcoming events and marketing emails.':
      'Dostávejte informace o nadcházejících akcích (zahrnuje také marketingové e-maily).',

    'Account Settings': 'Nastavení účtu',
    'Degree Prefix': 'Titul před jménem',
    'Degree Suffix': 'Titul za jménem',
    Gender: 'Pohlaví',
    'Facebook URL': 'Facebook URL',
    'Twitter URL': 'Twitter URL',
    'LinkedIn URL': 'LinkedIn URL',
    'Website URL': 'Webová stránka URL',
    Avatar: 'Avatar',
    'Cover Image': 'Obrázek na pozadí',
    'Change Password': 'Změnit heslo',
    'Confirm Password': 'Potvrdit heslo',
    'Save Changes': 'Uložit změny',
    'Passwords do not match': 'Hesla se neshodují',
    delete_account: 'Smazání účtu událostí',
    delete_account_message:
      'Pokud si přejete smazat svůj účet, kontaktujte nás na',
    delete_account_soon:
      'Tato funkce bude brzy k dispozici (zatím to musíme udělat manuálně - omlouváme se).',
    back_to_settings: 'Zpět na nastavení',
    legal_pages: 'Právní dokumenty',
    please_select_a_document: 'Vyberte prosím dokument',
    terms_of_service: 'Podmínky služby (VOP)',
    privacy_policy: 'Ochrana osobních údajů',
    cookie_policy: 'Zásady používání cookies',
    contact_us: 'Kontaktujte nás',
    back_to_event_list: 'Zpět na seznam událostí'
  },

  sk: {
    'Sign in to your account': 'Prihláste sa na svoj účet',
    'Email address': 'Emailová adresa'
  },
  en: {
    cookie_notification: {
      message:
        'This website uses cookies that are necessary for the operation of this service. The cookies will be stored for {days} days.',
      info: 'For more information, please refer to our <a href="{privacy_policy}">privacy policy</a> and <a href="{terms_of_service}">terms of service</a>. If you have any questions, feel free to <a href="{contact}">contact us</a>.',
      agree: 'I Agree',
      disagree: 'I Disagree',
      agree_close: 'Agree and Close'
    },
    "Omezená kapacita %s míst": "Limited capacity of %s spots",
    "Kapacita pouze %s míst": "Limited capacity of only %s spots", 
    "Maximální kapacita %s účastníků": "Maximum capacity of %s attendees",
    "Zajistěte si místo! Kapacita omezena na %s míst": "Secure your spot! Capacity limited to %s attendees",
    "Získejte své místo. Kapacita omezena na %s účastníků": "Get your spot. Limited to only %s attendees",
    status_badge: {
      planned: 'Planned',
      upcoming: 'Upcoming',
      live: 'Live',
      ended: 'Ended',
      playback: 'Playback Available',
      unknown: 'Unknown'
    },
    cookies_required: {
      title: 'We apologize, but this service cannot be used without cookies.',
      message:
        'Please enable cookies to continue. The cookie will be stored for {days} days.',
      privacy_policy: 'Privacy Policy',
      terms_of_service: 'Terms of Service',
      contact: 'Contact',
      accept_cookies: 'Accept Cookies'
    },
    private_message:
      'If you want to access this event, you need to enter the password.Password has been shared with you by the event organizer.',
    result: 'result',
    results: 'results',
    few_results: 'results',
    many_results: 'results',
    '%s %s for category „%s“ which contain „%s“':
      '%s %s for category “%s“ which contain “%s“',
    '%s %s for category „%s“': '%s %s for category “%s“',
    '%s %s for search term „%s“': '%s %s for search term “%s“',
    '%s %s found': '%s %s found',
    no_results_for_category_search:
      'No results found for category “%s“ which contain “%s“', // Add this line
    no_results_for_category: 'No results found for category “%s“', // Add this line
    no_results_for_search: 'No results found for search term “%s“', // Add this line
    no_results_found: 'No results found', // General no results line
    events_all_tab_name: 'All Events',
    events_all_tab_plural: 'All Events',
    events_all_tab_accusative: 'Events',
    event_mode_online_description_1:
      'You can join this event from the comfort of your home or office. Once the event begins, you will be automatically connected directly on this page.',
    event_mode_online_description_2:
      'After registering for the event, you will also receive an email with a link to join the event directly via a desktop application. You can use this solution, for example, in case of technical difficulties.',
    event_mode_online_description_3:
      'A recording of the event will also be made available to all registered participants, usually a few hours after the event concludes. This means that if you are unable to attend for any reason, you can watch the video recording at any time later.',
    rating_existing_review:
      'Thanks for submitting your review, feel free to edit if you changed your mind',
    rating_new_review: 'You have not submitted a review yet',
    instructorRating: 'How would you rate the instructor?',
    instructorRatingExplanation:
      '1 star = The instructor was unclear, unprepared, and struggled to answer questions.<br>10 stars = The instructor was very clear, well-prepared, and responded excellently to questions.',
    contentRating: 'How would you rate the quality of the content?',
    contentRatingExplanation:
      '1 star = The content was confusing, unclear, and did not provide any useful information.<br>10 stars = The content was logically structured, clear, and provided valuable and useful information.',
    technicalRating: 'How would you rate the performance of our event system?',
    technicalRatingExplanation:
      '1 star = I was unable to join or use the system due to technical problems.<br>10 stars = Everything worked perfectly, and I had no issues with the system.',
    incomplete_account_information: 'Incomplete Account Information',
    account_missing_information_message:
      'This account has missing information. Please update your account details before continuing.',
    go_to_settings: 'Go to Settings',
    delete_account: 'Delete Account',
    delete_account_message:
      'If you wish to delete your account, please contact us at',
    delete_account_soon: 'This feature will be available soon.',
    back_to_settings: 'Back to Settings',
    legal_pages: 'Legal Pages',
    please_select_a_document: 'Please select a document',
    terms_of_service: 'Terms of Service',
    privacy_policy: 'Privacy Policy',
    cookie_policy: 'Cookie Policy',
    back_to_event_list: 'Back to Event List'
  }
}

function translate (key, params = []) {
  const language = window.vueAppConfig?.settings?.language || 'cs'

  // Try to find the translation for the full key first
  let translatedText = translations[language]?.[key] || null

  // If no direct match is found, attempt dot-notation lookup for nested keys
  if (!translatedText) {
    translatedText =
      key
        .split('.')
        .reduce((obj, k) => (obj ? obj[k] : null), translations[language]) ||
      key
  }

  // Handle array-based parameters (e.g., '%s %s')
  if (Array.isArray(params)) {
    let paramIndex = 0
    translatedText = translatedText.replace(/%s/g, () => {
      return paramIndex < params.length ? params[paramIndex++] : '%s'
    })
  }

  // Handle object-based parameters (e.g., '{placeholder}')
  if (typeof params === 'object' && !Array.isArray(params)) {
    translatedText = translatedText.replace(/{(\w+)}/g, (_, placeholder) => {
      return params[placeholder] !== undefined
        ? params[placeholder]
        : `{${placeholder}}`
    })
  }

  return translatedText
}

export { translate }
